import AnionTestingPart from './AnionTestingPart';

export default function Part6Sulfate() {
  return (
    <AnionTestingPart
      partNumber={6}
      anionSymbol="SO42-"
      anionName="Sulfate"
      anionFormula="0.2 M H₂SO₄"
      anionColor="#E3F2FD"
      infoContent={{
        title: 'Sulfate Solubility',
        content: 'Most sulfates are soluble! Exceptions include BaSO₄ (white, very insoluble) and CaSO₄ (slightly soluble, may form faint precipitate).',
        equation: 'Ba2+(aq) + SO42-(aq) -> BaSO₄(s) [fine white precipitate]'
      }}
    />
  );
}
